import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import {
  faFacebook,
  faWhatsapp,
  faLinkedin,
} from '@fortawesome/free-brands-svg-icons';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { FetchDataService } from 'src/app/shared/services/fetch-data.service';
import { UserInfoService } from 'src/app/shared/services/UserInfoService/user-info.service';
import { ComponentService } from 'src/app/shared/services/ComponentService/component.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements AfterViewInit, OnDestroy {
  @Input() lang!: string;

  faFacebook = faFacebook;
  faWhatsapp = faWhatsapp;
  faLinkedin = faLinkedin;

  logoPath = `/assets/${environment.projectName}/media/header/logo.png`;
  whiteLogoPath = `/assets/${environment.projectName}/media/header/logo.png`;

  languages: any[] = [];
  selectedLanguage: any;
  tabs: any[] = [];
  userInfo: any;

  private destroy$ = new Subject<void>();

  @ViewChild('menu_icon') menu!: ElementRef;
  @ViewChild('close_icon') close!: ElementRef;
  @ViewChild('header') header!: ElementRef;

  constructor(
    private router: Router,
    private translate: TranslateService,
    private fetchDataService: FetchDataService,
    private componentService: ComponentService,
    private userInfoService: UserInfoService,
  ) {
    // ✅ subscribe instead of reading once — updates live on login/logout
    this.userInfoService.userInfo$
      .pipe(takeUntil(this.destroy$))
      .subscribe((info) => {
        this.userInfo = info;
      });

    this.fetchDataService.getJSONheader().subscribe({
      next: (data: any) => {
        this.tabs = data?.tabs || [];
        this.languages = data?.languages || [];
        this.selectLanguage(this.lang);
      },
      error: (err) => console.error('Error fetching header data:', err),
    });
  }

  ngAfterViewInit(): void {
    if (this.menu?.nativeElement) {
      this.menu.nativeElement.addEventListener('click', () => {
        this.header?.nativeElement?.classList.remove('d-none');
      });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  selectLanguage(lang: string): void {
    this.selectedLanguage = this.languages.find(
      (item: any) => item.value === lang,
    );
    this.translate.setDefaultLang(lang);
    this.closeNavbar();
  }

  closeNavbar(): void {
    this.header?.nativeElement?.classList.add('d-none');
  }

  getNewURL(lang: string): string {
    const url = this.router.url;
    return url.replace(/\/[a-z]{2}(\/|$)/, `/${lang}$1`);
  }
}
